import React, { MouseEventHandler, PureComponent } from 'react';
import { MdRemoveRedEye } from 'react-icons/md';
import { FormatterUtils } from '../../utils/formatter.utils';
import { CustomIconIndicator } from '../CustomIconIndicator/CustomIconIndicator';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

import './CardInfoNumber.scss';

export interface CardInfoNumberProps {
  title?: string;
  tooltip?: string;
  link?: string;
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>
  highlighValue?: number;
  highlighUnit?: string;
  secondaryValue?: number;
  secondaryUnit?: string;
  referenceValue?: number;
  referenceUnit?: string;
}

export class CardInfoNumber extends PureComponent<CardInfoNumberProps> {
  private getValueIndicator(value): string {
    if (!isNaN(value)) {
      return FormatterUtils.formatNumber(value);
    }
    return '';
  }

  private handleTextValue(value, unit): string {
    let text = this.getValueIndicator(value) + (unit ?? '').replace(/ /g, '\u00a0');
    return text;
  }

  render() {
    return (
      <CustomTooltip tooltip={this.props.tooltip}>
        <div
          className={
            'full-height customCardInfoNumber pointer' +
            (this.props.selected ? ' active' : '')
          }
          onClick={this.props.onClick}
        >
          <CustomIconIndicator
            className='icon-indicator'
            disabled={!this.props.link}
            link={this.props.link || '#'}
          >
            <CustomTooltip tooltip='Acesse mais informações'>
              <MdRemoveRedEye />
            </CustomTooltip>
          </CustomIconIndicator>
          <div className='cardInfoNumberInfoHeader'>
            {this.props.title}
          </div>
          <div className='cardInfoNumberInfoValue'>
            <span className='cardInfoNumberInfoPrimaryValue'>
              {this.handleTextValue(this.props.highlighValue, this.props.highlighUnit)}
            </span>
            <span className='cardInfoNumberInfoSubValue'>
              {this.handleTextValue(this.props.secondaryValue, this.props.secondaryUnit)}
            </span>
          </div>
          <div className='cardInfoNumberInfoFooter'>
            Na unidade da federação:{' '}
            {this.handleTextValue(this.props.referenceValue, this.props.referenceUnit)}
          </div>
        </div>
      </CustomTooltip>
    );
  }
};
